module.exports = __webpack_public_path__ + "img/motrin_pm_coated_caplets.88033947.jpg";